import { ImageLinkData } from '../../../Content';

interface ImageLinkContentProps {
  content: ImageLinkData;
}

export const ImageLinkContent: React.FC<ImageLinkContentProps> = ({
  content,
}) => {
  return (
    <a href={content.href} target="_blank" rel="noreferrer">
      <img
        alt={content.title}
        style={{
          width: '100%',
          height: 'auto',
          margin: 0,
        }}
        src={content.src}
      />
    </a>
  );
};
